import React, { useContext, useMemo, useCallback } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import { getRestaurantsShortInfo } from 'backend/restaurants';
import { IGetRestaurantsShort, IGetRestaurantsShortArgs } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import MultipleSelect from './components/MultipleSelect';
import RestaurantsList from 'components/Lists/CardView/RestaurantsList';
import style from './RestaurantsMultipleSelect.module.scss';

const RestaurantsMultipleSelect: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { setIDsRestaurant, IDsSelectedRestaurant } = useContext<IScheduleViewContext>(ScheduleViewContext);
	const { response, loading, refetch, responseError } = useFetchData<IGetRestaurantsShort, IGetRestaurantsShortArgs>(
		customerForFullInfo?.id ? getRestaurantsShortInfo : null,
		{
			customerId: customerForFullInfo?.id || '',
		},
	);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = IDsSelectedRestaurant.filter((el) => el !== id);
			setIDsRestaurant(updatedSelectedItems);
		},
		[IDsSelectedRestaurant, setIDsRestaurant],
	);

	const restaurantsList = useMemo(() => {
		return IDsSelectedRestaurant.map((el) => ({
			id: el,
			restaurantName: response?.data.restaurants.find((item) => item.id === el)?.name || '',
		}));
	}, [IDsSelectedRestaurant, response, handleRemove]);

	return (
		<div className={style.container} data-test="RestaurantsMultipleSelect">
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.restaurants || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					setIDsRestaurant={setIDsRestaurant}
					customerId={customerForFullInfo?.id || ''}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
				/>
			</div>
			{!!restaurantsList.length && (
				<div className={style.restaurantList}>
					<RestaurantsList restaurants={restaurantsList} />
				</div>
			)}
		</div>
	);
};

export default React.memo(RestaurantsMultipleSelect);
